var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPmLogo = function SvgPmLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1E",
    d: "M0 4.5A4.5 4.5 0 0 1 4.5 0h9A4.5 4.5 0 0 1 18 4.5v9a4.5 4.5 0 0 1-4.5 4.5h-9A4.5 4.5 0 0 1 0 13.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F3",
    d: "M3 12V6h2.367q.683 0 1.163.26.48.259.733.719.255.457.255 1.054 0 .598-.258 1.055t-.747.712q-.487.255-1.178.255H3.826V9.038H5.13q.366 0 .603-.126a.84.84 0 0 0 .358-.354q.12-.23.12-.525 0-.299-.12-.521a.8.8 0 0 0-.358-.349 1.3 1.3 0 0 0-.609-.126h-.855V12zm5.342-6h1.564l1.652 4.031h.07L13.282 6h1.564v6h-1.23V8.095h-.05l-1.553 3.876h-.837L9.622 8.08h-.05V12h-1.23z"
  })));
};
export default SvgPmLogo;